module.exports = __webpack_public_path__ + "media/images/lms/sakai-2c34bfcee55b28abaddff5a947437a1a.png";